import { Module } from 'vuex'
import Participante from '../models/participante'
import participanteService from '../services/participante'
import { ParticipantResult } from '../services/participante'
import Swal from 'sweetalert2'

export type ParticipanteData = Participante | null
export interface ParticipantData {
  data: ParticipanteData
}

// eslint-disable-next-line
export interface ParticipantModuleState extends ParticipantData {}

const paticipantModule: Module<ParticipantModuleState, any> = {
  namespaced: true,
  state: {
    data: null,
  },

  mutations: {},

  actions: {
    async setAutorPass(
      _,
      { data, componente }: { data: any; componente: any }
    ): Promise<ParticipantResult | null> {
      let result: ParticipantResult
      try {
        result = await participanteService.setAutorPass(data)
      } catch (err) {
        Swal.fire(
          'Error',
          'No se completo el registro, intente nuevamente',
          'error'
        )
        return null
      }

      if (!result.error) {
        Swal.fire('Éxito', 'Su registro fue Exitoso ', 'success').then(() => {
          componente.$router.push('/login')
        })
      } else {
        Swal.fire('Error', result.error, 'error')
      }
      return result
    },

    async autorPass(
      _,
      { data, componente }: { data: any; componente: any }
    ): Promise<ParticipantResult | null> {
      let result: ParticipantResult
      try {
        result = await participanteService.autorPass(data)
      } catch (err) {
        Swal.fire(
          'Error',
          'No se completo el registro, intente nuevamente',
          'error'
        )
        return null
      }

      if (!result.error) {
        Swal.fire('Éxito', 'Su registro fue exitoso ', 'success').then(() => {
          componente.$router.push('/login')
        })
      } else {
        Swal.fire('Error', result.error, 'error')
      }
      return result
    },

    async setEvaluador(
      _,
      { data, componente }: { data: any; componente: any }
    ): Promise<ParticipantResult | null> {
      let result: ParticipantResult
      try {
        result = await participanteService.setEvaluador(data)
      } catch (err) {
        Swal.fire(
          'Error',
          'No fue posible actualizar sus datos, intente nuevamente',
          'error'
        )
        return null
      }

      if (!result.error) {
        Swal.fire('Éxito', 'Su registro fue exitoso ', 'success').then(() => {
          componente.$router.push('/login')
        })
      } else {
        Swal.fire('Error', result.error, 'error')
      }
      return result
    },
  },
}

export default paticipantModule
